import type { HTMLAttributes } from 'react';
import type React from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { DecisionMakerResponseByLine } from './components/DecisionMakerResponseByLine';
import { DecisionMakerResponseMedia } from './components/DecisionMakerResponseMedia';
import { usePageHeading } from './hooks/usePageHeading';

export const PageHeading: React.FC<HTMLAttributes<HTMLDivElement>> = (props) => {
	const {
		data: { title, type, petitionTitle, petitionUrl },
	} = usePageHeading();

	return (
		<div className="px-4 sm:px-2" {...props}>
			<Text variant="body" size="medium" fontWeight="bold" data-qa="dm-response-type">
				{type}
			</Text>
			<div className="pt-4">
				<Link href={petitionUrl} data-qa="petition-title-link" size="small">
					{petitionTitle}
				</Link>
			</div>
			<Text
				variant="heading"
				as="h1"
				data-qa="dm-response-title"
				size="x-large"
				className="mt-4 mb-6 wrap-break-word md:mb-[52px]"
			>
				{title}
			</Text>
			<DecisionMakerResponseByLine />
			<DecisionMakerResponseMedia />
		</div>
	);
};
